import { gql } from '@plato/app-core/gql';
import { useQuery } from '@plato/app-core/hooks/use-query';
import {
    filterViewTypenames,
    SavedFilterViews,
    type SavedFilterViewsProps,
} from '@plato/app-shared/components/saved-filter-views';
import type { AnyFilter } from '@plato/ui-legacy/components/filters/types/filter-types';
import type { ReactElement } from 'react';

const savedFilterViewsForViewKeyQuery = gql(/* GraphQL */ `
    query SavedFilterViewsForViewKey($viewKey: String!) {
        filterViews(viewKeys: [$viewKey]) {
            ...SavedFilterViews_FilterView
        }
    }
`);

type SavedFilterViewsForViewKeyProps<TFilter extends AnyFilter> = Omit<
    SavedFilterViewsProps<TFilter>,
    'views'
>;

export function SavedFilterViewsForViewKey<TFilter extends AnyFilter>(
    props: SavedFilterViewsForViewKeyProps<TFilter>,
): ReactElement {
    const [{ data }] = useQuery({
        query: savedFilterViewsForViewKeyQuery,
        variables: { viewKey: props.viewKey },
        context: filterViewTypenames,
    });

    return <SavedFilterViews<TFilter> views={data?.filterViews} {...props} />;
}
